var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _g, _rect8, _rect9, _rect10, _rect11, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmptyFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 202,
    viewBox: "0 0 319 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318.833 155.549C318.833 143.452 302.037 131.851 272.141 123.297C242.244 114.743 201.696 109.938 159.416 109.938C117.137 109.937 76.5884 114.743 46.692 123.297C16.7956 131.851 6.38408e-06 143.452 0 155.549L159.416 155.549H318.833Z",
    fill: "url(#paint0_linear_1450_9168)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 108.541,
    y: 47.7188,
    width: 94.8124,
    height: 68.1931,
    rx: 4.78548,
    fill: "#787878"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 115.74,
    y: 29.0547,
    width: 48.2981,
    height: 66.2438,
    rx: 5.76033,
    transform: "rotate(-8.72324 115.74 29.0547)",
    fill: "#D2D2D2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 115.74,
    y: 29.0547,
    width: 48.2981,
    height: 66.2438,
    rx: 5.76033,
    transform: "rotate(-8.72324 115.74 29.0547)",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 121.402,
    y: 38.0234,
    width: 40.5438,
    height: 7.40258,
    rx: 0.886204,
    transform: "rotate(-8.72324 121.402 38.0234)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 123.496,
    y: 50.8828,
    width: 40.5438,
    height: 7.40258,
    rx: 0.886204,
    transform: "rotate(-8.72324 123.496 50.8828)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 128.168,
    y: 85.2031,
    width: 40.5438,
    height: 3.76637,
    rx: 0.886204,
    transform: "rotate(-8.72324 128.168 85.2031)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 127.26,
    y: 79.2891,
    width: 40.5438,
    height: 3.76637,
    rx: 0.886204,
    transform: "rotate(-8.72324 127.26 79.2891)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1450_9168)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.4745,
    height: 82.9443,
    rx: 3.58911,
    transform: "matrix(-0.987607 -0.156946 -0.156946 0.987607 220.494 11.4922)",
    fill: "#D2D2D2"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 50.7653,
    height: 16.4165,
    rx: 1.10962,
    transform: "matrix(-0.987607 -0.156946 -0.156946 0.987607 214.193 17.7031)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 51.3861,
    height: 4.7159,
    rx: 1.10962,
    transform: "matrix(-0.987607 -0.156946 -0.156946 0.987607 209.98 43.8203)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 50.7653,
    height: 4.7159,
    rx: 1.10962,
    transform: "matrix(-0.987607 -0.156946 -0.156946 0.987607 204.561 81.7109)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 50.7653,
    height: 4.7159,
    rx: 1.10962,
    transform: "matrix(-0.987607 -0.156946 -0.156946 0.987607 205.738 74.3125)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.775 61.1735C132.092 53.1999 140.024 48.1352 148.653 48.48L219.86 51.3256C226.751 51.6009 231.098 58.8531 228.092 65.0601L204.775 113.215C203.975 114.866 202.302 115.915 200.468 115.915H113.174C109.76 115.915 107.444 112.443 108.756 109.291L128.775 61.1735Z",
    fill: "#959595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.66 19.9026L122 14.6953",
    stroke: "#BEBEBE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.713 18.5826L134.25 12.4062",
    stroke: "#BEBEBE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.241 18.8493L128.203 13.2812",
    stroke: "#BEBEBE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3145 98.8652C67.9504 98.3667 77.5513 93.9301 78.8673 80.1719",
    stroke: "#CECECE",
    strokeWidth: 1.79456
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M247.003 95.8875C248.018 94.8723 249.823 95.8875 250.598 96.5219C254.913 99.652 248.871 102.338 245.311 103.29C245.452 101.245 245.988 96.9026 247.003 95.8875Z",
    fill: "#CECECE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M252.396 94.7243L250.598 96.5219M250.598 96.5219C249.823 95.8875 248.018 94.8723 247.003 95.8875C245.988 96.9026 245.452 101.245 245.311 103.29C248.871 102.338 254.913 99.652 250.598 96.5219Z",
    stroke: "#A3A3A3",
    strokeWidth: 0.149546
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M256.229 93.3339C260.864 92.8354 270.465 88.3989 271.781 74.6406",
    stroke: "#CBCBCB",
    strokeWidth: 1.19637
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M242.77 88.7004C250.793 87.8391 267.41 80.1727 269.688 56.3984",
    stroke: "#CBCBCB",
    strokeWidth: 1.19637
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1450_9168",
    x: 142.796,
    y: 0.631341,
    width: 77.8683,
    height: 96.5363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.39274,
    dy: 1.19637
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.54033
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1450_9168"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1450_9168",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1450_9168",
    x1: 0,
    y1: 155.549,
    x2: 0,
    y2: 14.5269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyFolder);
export default __webpack_public_path__ + "static/media/icon-emptyFolder.c56fb8ad948d7f7a4fadccfd8c3b2db0.svg";
export { ForwardRef as ReactComponent };